module.exports = __webpack_public_path__ + "img/pie-chart.9d036e68.svg";